module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Lucia-3d386ba06d264a60216a47a16e79fff2.png";